"use strict";

/*
*
*   CLIENT LOGO UPLOADER
*
*/

// Class definition
var KTUploaderBannerOffer = function () {
	// Elements
	var logo;

	var _initForm = function() {
    	logo = new KTImageInput('kt_offer_banner');
	}

	return {
		// public functions
		init: function() {
			_initForm();
		}
	};
}();

jQuery(document).ready(function() {
	KTUploaderBannerOffer.init();
});
